import React from 'react';

import { StarGray } from '@travel/icons/ui';
import { useDeviceTypes } from '@travel/traveler-core/hooks';
import { cx } from '@travel/utils';

import styles from './myReviewLoader.module.scss';

const MyReviewLoader = () => {
  const stars = Array.from({ length: 5 }, (_, i) => (
    <StarGray key={i} className={styles.loadingStar} size={16} />
  ));
  const { isPC } = useDeviceTypes();
  const userReviewSection = (
    <div className={styles.userReviewSection} data-testid="MyReviewLoader-ReviewSection">
      <div className={styles.hotelInfo}>
        <div className={styles.rowOne}>
          <div className={cx(styles.hotelPicture, styles.bgLoader)} />
          <div className={styles.hotelTitle}>
            <div className={cx(styles.rowOne, styles.bgLoader)} />
            <div className={cx(styles.rowTwo, styles.bgLoader)} />
          </div>
        </div>
        <div className={styles.rowTwo}>
          <div className={cx(styles.rowOne, styles.bgLoader)} />
          <div className={cx(styles.rowTwo, styles.bgLoader)} />
          <div className={cx(styles.rowOne, styles.bgLoader)} />
          <div className={cx(styles.rowTwo, styles.bgLoader)} />
        </div>
      </div>
      <div className={styles.reviewInfo}>
        <div className={styles.starContainer}>
          {stars}
          <div className={cx(styles.rowOne, styles.bgLoader, styles.borderRadiusFull)} />
        </div>
        <div className={cx(styles.rowOne, styles.borderRadiusFull)} />
        <div className={styles.reviewPicSection}>
          {[...Array(4)].map((_, i) => (
            <div key={i} className={cx(styles.pics, styles.bgLoader)} />
          ))}
          {!isPC && (
            <div className={cx(styles.picsContainerSP)}>
              <div className={cx(styles.group)}>
                <div className={cx(styles.largeBox, styles.bgLoader)} />
                <div className={cx(styles.smallBoxes)}>
                  <div className={cx(styles.smallBox, styles.bgLoader)} />
                  <div className={cx(styles.smallBox, styles.bgLoader)} />
                </div>
              </div>
              <div className={cx(styles.group)}>
                <div className={cx(styles.largeBox, styles.bgLoader)} />
                <div className={cx(styles.smallBoxes)}>
                  <div className={cx(styles.smallBox, styles.bgLoader)} />
                  <div className={cx(styles.smallBox, styles.bgLoader)} />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={cx(styles.row2, styles.bgLoader, styles.borderRadiusFull)} />
        <div className={cx(styles.row3, styles.bgLoader, styles.borderRadiusFull)} />
        <div className={cx(styles.row4, styles.bgLoader, styles.borderRadiusFull)} />
        {!isPC && <div className={cx(styles.row4SP, styles.bgLoader, styles.borderRadiusFull)} />}

        <div className={cx(styles.row6, styles.bgLoader, styles.borderRadiusFull)} />
        <div className={cx(styles.row7, styles.bgLoader, styles.borderRadiusFull)} />
        <div className={cx(styles.row8, styles.bgLoader)} />
      </div>
    </div>
  );
  const userInfoSec = (
    <div className={styles.userInfoSection} data-testid="MyReviewLoader-UserInfoSection">
      <div className={cx(styles.profilePic, styles.bgLoader, styles.borderRadiusFull)}></div>

      <div className={styles.profileInfo}>
        <div className={cx(styles.bgLoader, styles.rowOne)} />
        {[...Array(2)].map((_, i) => (
          <div key={i} className={cx(styles.bgLoader, styles.rowTwo)} />
        ))}
        {!isPC && <div className={cx(styles.bgLoader, styles.rowThreeSP)} />}
        <div className={cx(styles.bgLoader, styles.rowThree)} />
        <div className={cx(styles.rowFour)}>
          {[...Array(3)].map((_, i) => (
            <div key={i} className={styles.bgLoader} />
          ))}
        </div>
      </div>
      <div className={cx(styles.profileSns, styles.bgLoader)} />
    </div>
  );

  return (
    <div className={styles.reviewLoaderContainer} data-testid="MyReviewLoader-Skeleton">
      {userInfoSec}
      {userReviewSection}
      {userReviewSection}
    </div>
  );
};

export default MyReviewLoader;
